export default __webpack_public_path__ + "static/media/receipt-active.86d22444.svg";